import React from "react";
import { Button, Drawer, Space } from "antd";

const RecordForm = ({
  editing,
  fields,
  formValues,
  onCancel,
  onChange,
  onSave,
  open,
  saving,
  title,
}) => (
  <Drawer
    footer={
      <Space style={{ display: "flex", justifyContent: "flex-end" }}>
        <Button onClick={onCancel}>Cancel</Button>
        <Button
          loading={saving}
          onClick={onSave}
          style={{ background: "#1cc400", borderColor: "#1cc400" }}
          type="primary"
        >
          {saving ? "Saving..." : "Save"}
        </Button>
      </Space>
    }
    onClose={onCancel}
    open={open}
    title={title}
    width={480}
    styles={{ body: { overflowY: "auto", padding: "24px" } }}
  >
    <div className="admin-form-grid">
      {fields.map((field) => {
        if (field.hidden) return null;
        if (field.createOnly && editing) return null;
        const required = field.required || (!editing && field.createOnly);

        return (
          <div className="admin-field" key={field.name}>
            <label htmlFor={`admin-${field.name}`}>{field.label}</label>
            {field.type === "select" ? (
              <select
                className="admin-select"
                id={`admin-${field.name}`}
                onChange={(e) => onChange(field.name, e.target.value)}
                required={required}
                value={formValues[field.name] || ""}
              >
                {field.placeholder && (
                  <option disabled value="">
                    {field.placeholder}
                  </option>
                )}
                {field.options.map((option) => (
                  <option key={option} value={option}>
                    {option.replace("_", " ")}
                  </option>
                ))}
              </select>
            ) : (
              <input
                className="admin-input"
                id={`admin-${field.name}`}
                min={field.type === "number" ? "0" : undefined}
                onChange={(e) => onChange(field.name, e.target.value)}
                placeholder={field.placeholder || ""}
                required={required}
                type={field.type || "text"}
                value={formValues[field.name] || ""}
              />
            )}
          </div>
        );
      })}
    </div>
  </Drawer>
);

export default RecordForm;
